export default __webpack_public_path__ + "static/bike-route-e85db119fce41cd3be818e207eb0a2a6.jpg";